import AppRoutes from '../views/config/AppRoutes';

// #cfa2-2027 — mirror of cfa1NextRoutes.js. Keep a 2027 user inside the /cfa2/2027/... tree when
// SHARED components navigate internally. Unlike CFA1 (which reuses its 2025 components wholesale),
// the CFA2 2027 learn/QB/notes/quiz/CBT views are CLONED and already carry their own CFA2_2027_*
// route constants, so they don't need this. The only genuinely shared CFA2 components are the video
// list/player (views/Videos/*, edition-neutral /exams/cfa/videos/* endpoints) — nextAwareRoute()
// swaps their shared /videos route constants to the /cfa2/2027 variants while under that tree, so
// 2025/2026 navigation is completely unaffected.
// Both dated CFA2 trees reuse the shared video components, so each prefix maps the shared route
// constants to its own dated variants. Checked most-specific first.
const DATED_TREES = [
  {
    prefix: '/cfa2/2027',
    map: {
      [AppRoutes.VIDEOS]: AppRoutes.CFA2_2027_VIDEOS,
      [AppRoutes.VIDEOS_LIST]: AppRoutes.CFA2_2027_VIDEOS_LIST,
    },
  },
  {
    prefix: '/cfa2/2026',
    map: {
      [AppRoutes.VIDEOS]: AppRoutes.CFA2_2026_VIDEOS,
      [AppRoutes.VIDEOS_LIST]: AppRoutes.CFA2_2026_VIDEOS_LIST,
    },
  },
];

// Current route path, read straight from the browser URL so it works regardless of the react-router
// history in use: browserHistory keeps the route in window.location.pathname; hashHistory keeps it
// in the hash (#/path). Prefer the hash when present, else the pathname.
export const getCurrentPath = () => {
  const hash = (window.location && window.location.hash) || '';
  if (hash.length > 1) {
    return hash.replace(/^#/, '').split('?')[0];
  }
  return (window.location && window.location.pathname) || '';
};

// The dated-tree entry whose prefix the current route is under, or null (plain /videos etc.).
const currentDatedTree = () => {
  const p = getCurrentPath();
  if (!p) return null;
  for (let i = 0; i < DATED_TREES.length; i++) {
    if (p.indexOf(DATED_TREES[i].prefix) === 0) return DATED_TREES[i];
  }
  return null;
};

// True when the current route is inside either dated CFA2 tree.
export const isNextPath = () => !!currentDatedTree();

// Legacy shared /videos URLs are shared with CFA3, so a plain route redirect is impossible. Redirect
// only CFA2 users (by the selected exam code) into their dated tree; CFA3/others stay on /videos.
// Used as onEnter on the shared AppRoutes.VIDEOS / VIDEOS_LIST routes.
const CFA2_VIDEO_PREFIX_BY_EXAM = {
  cfa_2: '/cfa2/2026',
  cfa_2_2025: '/cfa2/2026',
  cfa_2_2026: '/cfa2/2026',
  cfa_2_2027: '/cfa2/2027',
};
export const redirectSharedVideosToCfa2Tree = (nextState, replace) => {
  let exam = '';
  try {
    exam = localStorage.getItem('selectedmenu') || '';
  } catch (e) {
    exam = '';
  }
  const prefix = CFA2_VIDEO_PREFIX_BY_EXAM[exam];
  if (!prefix) return;
  const loc = nextState.location;
  // /videos → <prefix>/videos ; /videos/list/:chapterId/:id → <prefix>/video/list/:chapterId/:id
  const rest = loc.pathname.replace(/^\/videos/, '');
  const target = rest.indexOf('/list/') === 0 ? `${prefix}/video${rest}` : `${prefix}/videos`;
  replace(target + (loc.search || ''));
};

// Given a shared CFA2 route constant (a route template), return the dated variant for the tree the
// user is currently inside (/cfa2/2026 or /cfa2/2027); otherwise return the original unchanged. Param
// substitution stays the caller's job — this only swaps the template.
export const nextAwareRoute = (routeConstant) => {
  const tree = currentDatedTree();
  if (tree && tree.map[routeConstant]) {
    return tree.map[routeConstant];
  }
  return routeConstant;
};



// WEBPACK FOOTER //
// ./src/common/cfa2NextRoutes.js